import React from "react";
import { func, node, number, object, string } from "prop-types";
import { LoadMoreCollectionStories } from "@quintype/components";

import { DfpComponent } from "../../../ads/dfp-component";
import DfpContainer from "../../../ads/dfp-container";
import More from "../../../atoms/More";
import LeftImageRightNews from "../../../molecules/LeftImageRightNews";

import { staticTexts } from "../../../utils/Translate";
import { getSlotId } from "../../../utils/utils";

import "./organism1.m.css";

const Organism1 = ({ collection, lang, adSlot1 = "", numberOfStoriesSkipToShow = 0, widget }) => {
  const { items = [], "associated-metadata": { number_of_stories_to_show: numberOfStoriesShow } = {} } = collection;
  const storyList = [];

  for (const item of items) {
    const { type, story } = item;
    if (type === "story") storyList.push(story);
  }

  if (!storyList.length) {
    return null;
  }

  const MoreCollectionStories = (params) => {
    const { stories, onLoadMore, noMoreStories, loading } = params;

    const MoreComponent = (
      <div styleName={`load-more-view`}>
        <More type="load-more" text={staticTexts(lang).more} showButtonSpinner={loading} onClick={onLoadMore} />
      </div>
    );

    return (
      <div styleName="base">
        {stories.map((story, index) => (
          <React.Fragment key={index}>
            {(index % 10 === 5 || index === 5) && (
              <DfpContainer>
                <div styleName="ad-wrapper" className="adsBox">
                  <DfpComponent
                    type={adSlot1}
                    slotId={getSlotId(adSlot1, collection?.slug, index)}
                    collectionSlug={collection?.slug}
                    layoutName="TenStories2AdWithLoadMore"
                  />
                </div>
              </DfpContainer>
            )}
            {index === 5 && widget}
            <LeftImageRightNews key={index} story={story} showExcerpt={!global.isMobile} widths={[200, 300, 370]} />
          </React.Fragment>
        ))}

        {!noMoreStories ? MoreComponent : null}
      </div>
    );
  };

  return (
    <LoadMoreCollectionStories
      template={MoreCollectionStories}
      collectionSlug={collection.slug}
      data={Object.assign(
        {},
        { collection: collection },
        {
          stories: [
            ...storyList
              .map((story) => story)
              .splice(numberOfStoriesSkipToShow, numberOfStoriesShow - numberOfStoriesSkipToShow),
          ],
        },
        { storiesPerPage: 15 }
      )}
      numStoriesToLoad={10}
      params={{ "item-type": "story" }}
    />
  );
};

Organism1.propTypes = {
  collection: object.isRequired,
  setLoading: func,
  lang: string,
  adSlot1: string,
  numberOfStoriesShow: number,
  numberOfStoriesSkipToShow: number,
  widget: node,
};

export default Organism1;
